export const config = {
  isDevelopment: import.meta.env.VITE_DEV_MODE === 'true',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  apiURL: import.meta.env.VITE_API_URL,
  botnexusApiBaseUrl: import.meta.env.VITE_BOTNEXUS_API_BASE_URL || import.meta.env.VITE_API_URL,
  chatAppURL: import.meta.env.VITE_CHAT_APP_URL,
}
